import { Injectable } from '@angular/core';

import { SandboxLocalStorageKeys } from '../enums';
import { ISandboxLocalStorage } from '../interfaces';

@Injectable()
export class SandboxLocalStorageService {
  setItemValue<T extends keyof ISandboxLocalStorage>(key: T, value: ISandboxLocalStorage[T]): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItemValue<T extends keyof ISandboxLocalStorage>(key: T): ISandboxLocalStorage[T] | null {
    const unparsedStorageItem = localStorage.getItem(key);

    if (unparsedStorageItem) {
      try {
        return JSON.parse(unparsedStorageItem);
      } catch (error) {
        console.error(`localStorage: incorrect value for key "${key}"`);
      }
    }

    return null;
  }

  removeItem(key: SandboxLocalStorageKeys): void {
    localStorage.removeItem(key);
  }
}
